import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import admin from './admin'
import shared from './shared'
import propduct from './product'
import supplier from './supplier'
import supplierProduct from './supplier/product'
import spa from './spa'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    supplierProduct,
    supplier,
    propduct,
    shared,
    admin,
    user,
    spa
  }
})
